import { FC } from 'react';
import { PROFIL_DESCRIPTION, ProfilSanitize, sanitizeHtml } from 'shared/utils/sanitizeHtml';

interface HtmlSanitizedProps {
  html: string;
  profil?: ProfilSanitize;
  className?: string;
  /** Balise porteuse du rendu. */
  as?: 'p' | 'div' | 'span';
}

/** Rend du HTML semi-confiance APRÈS assainissement — l'unique porte
 * d'entrée autorisée pour dangerouslySetInnerHTML dans l'app. */
export const HtmlSanitized: FC<HtmlSanitizedProps> = ({
  html,
  profil = PROFIL_DESCRIPTION,
  className,
  as: Balise = 'p',
}) => (
  <Balise className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html, profil) }} />
);
